import { PiArrowUpDuotone, PiArrowDownDuotone } from "react-icons/pi";
import { queryClient } from "../../../App";
import MarkdownRenderer from "../../tasks/components/MarkdownRenderer";
import TagBadge from "../../tasks/components/TagBadge";
import { Task } from "../../tasks/models/Task";
import { useMutation } from "react-query";
import { recordVote } from "../../tasks/utils/TaskUtils";
import { useAuth } from "../../authentication/AuthContext";
import { useShowTempErrorMessage, useShowTempMessage } from "../../shared/hooks/useUtilityContext";

export default function SnippetMetadata({
  snippet,
  title,
  description,
  tags,
}: {
  snippet?: Task;
  title?: string;
  description?: string;
  tags?: string[];
}) {
  const { user } = useAuth();
  const showTempErrorMessage = useShowTempErrorMessage();
  const showTempMessage = useShowTempMessage();

  const { mutate: handleVote } = useMutation(recordVote, {
    onSuccess: () => {
      queryClient.invalidateQueries(["task", snippet!.id]);
    },
  });

  return (
    <div className="w-full flex justify-center items-start mt-8">
      <div className="grow">
        {(title || snippet?.title) && (
          <h2 className="mx-2 md:mx-4 text-lg font-bold">
            {title ?? snippet!.title}
          </h2>
        )}
        {tags && tags.length > 0 && (
          <div className="card-actions mx-2 md:mx-4 mt-4">
            {(tags ?? [])?.map((tag, index) => (
              <TagBadge
                key={index}
                tag={tag}
              />
            ))}
          </div>
        )}
        {(description || snippet?.description) && (
          <div className="my-2 mx-2 md:mx-4">
            <MarkdownRenderer content={description ?? snippet!.description!} />
          </div>
        )}
        {snippet && (
          <div className="flex w-full mt-2 flex-col gap-1 md:gap-4 md:flex-row mx-2 md:mx-4">
            <div className="text-sm text-base-content font-thin">
              Asked on {new Date(snippet.created_at).toLocaleDateString()} at{" "}
              {new Date(snippet.created_at).toLocaleTimeString(undefined, {
                hour: "numeric",
                minute: "2-digit",
              })}
            </div>
            <div className="flex gap-4 text-sm text-base-content font-thin">
              <div className="">{(snippet.task_votes ?? []).length} votes</div>
              {/* <div className="">
                                          {task.edit_count}{" "}
                                          {task.edit_count == 1 ? "edit" : "edits"}
                                        </div> */}
            </div>
          </div>
        )}
      </div>
      {snippet && (
        <div className="flex flex-col justify-center mr-4">
          <PiArrowUpDuotone
            className={`cursor-pointer hover:scale-105 ${
              (snippet.task_votes ?? []).filter(
                (vote) => vote.user_id === user?.id && vote.value === 1
              ).length > 0 && "text-primary"
            }`}
            size={36}
            onClick={() =>
              handleVote({
                taskId: snippet.id!,
                value: 1,
                queryClient,
                showTempErrorMessage,
                showTempMessage,
                task: snippet,
                user: user!,
              })
            }
          />
          <div className="text-center text-xl font-bold py-2">
            {(snippet.task_votes ?? [])
              .map((vote) => vote.value)
              .reduce((a, b) => a + b, 0)}
          </div>
          <PiArrowDownDuotone
            className={`cursor-pointer hover:scale-105 ${
              (snippet.task_votes ?? []).filter(
                (vote) => vote.user_id === user?.id && vote.value === -1
              ).length > 0 && "text-primary"
            }`}
            size={36}
            onClick={() =>
              handleVote({
                taskId: snippet.id!,
                value: -1,
                queryClient,
                showTempErrorMessage,
                showTempMessage,
                task: snippet,
                user: user!,
              })
            }
          />
        </div>
      )}
    </div>
  );
}
